UsersIndex

<template>
    <div id="wrapper">
        <SidebarView :users="true" :user-visible="true" :audit="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="mx-3">
                    <!-- begin row  -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <div class="card card-shape home-box">
                                    <div class="card-header">
                                        <h6 class="m-0 fw-bold text-green">
                                            Excel Export
                                        </h6>
                                    </div>
                                    <!-- <div class="card-body">
										<div></div>
									</div> -->

                                    <div class="card-body default_bg"
                                        style="border-bottom: 1px solid rgb(1, 134, 115);">
                                        <div class="home-box border border-success py-1 bg-white">
                                            <div class="card-body">
                                                <!-- <member-filter :form="form" :filterTable="filterTable"></member-filter> -->
                                                <form @submit.prevent="filterTable()">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <label class="akkurate-dark small d-none d-lg-block"
                                                                for="search_term">Search Term</label>
                                                            <b-form-group id="search_term" label-for="search_term">
                                                                <b-form-input class="mt-2 field-container fields"
                                                                    type="text" v-model="form.search_term"
                                                                    placeholder="Search by firstname, lastname, phone number, email, staff ID">
                                                                </b-form-input>
                                                            </b-form-group>
                                                        </div>

                                                        <div class="col-md-4 mb-2">
                                                            <label class="akkurate-dark small"
                                                                for="trans_source">Users</label>
                                                            <multiselect class="mt-1 field-container"
                                                                v-model="form.users" :options="users_options"
                                                                placeholder="Select User" selectLabel="" :custom-label="fullName
                                                                    " :close-on-select="false
                                                                        " :clear-on-select="false
                                                                            " :multiple="true" deselectLabel=""
                                                                :limit-text="limitText
                                                                    " :limit="1" track-by="id">
                                                            </multiselect>
                                                        </div>
                                                        <div
                                                            class="d-grid gap-2 col-md-2 d-flex align-content-center justify-content-center mb-2 mt-auto">
                                                            <b-button type="submit"
                                                                class="akkurate-green-btn akkurate-auth-size w-100 d-flex align-items-center justify-content-center"><i
                                                                    class="fas fa-search"></i><span
                                                                    class="d-none d-lg-block ms-2">Search</span></b-button>
                                                            <b-button size="sm" v-b-modal.modal-member
                                                                title="show more filters" class="ms-2">
                                                                <i class="fas fa-bars akkurate-small"></i>
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0 px-0">
                                        <div class="table_text_size">
                                            <b-table striped bordered responsive id="users-table" :busy.sync="isBusy"
                                                :items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>
                                                <template #table-busy>
                                                    <div class="text-center text-danger my-2">
                                                        <b-spinner class="align-middle"></b-spinner>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </template>
                                                <template #cell(index)="data">
                                                    {{ data.index + 1 }}
                                                </template>
                                                <template #cell(user)="data">
                                                    <div class="text-center small">
                                                        {{
                                                            data.item.causer
                                                                ?.first_name
                                                        }}
                                                        {{
                                                            data.item.causer
                                                                ?.surname
                                                        }}
                                                    </div>
                                                </template>
                                                <template #cell(url)="data">
                                                    <a :href="data.item?.url">
                                                        <span class="akkurate-small"><font-awesome-icon
                                                                :icon="['fas', 'download']" /></span>
                                                    </a>
                                                </template>
                                                <template #cell(actions)="data">
                                                    <span class="d-flex">
                                                        <a v-if="
                                                            data.item?.status == 'pending'" title="Reverse"
                                                            class="btn btn-sm akkurate-primary text-white" @click="
                                                                reverseBulkUpload(data.item)">
                                                            <span class="akkurate-small"><font-awesome-icon :icon="[
                                                                'fas',
                                                                'backward',
                                                            ]" /></span>
                                                        </a>
                                                    </span>

                                                </template>
                                            </b-table>
                                            <div class="d-flex justify-content-between">
                                                <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
                                                    :total-rows="totalRecords" :per-page="perPage"
                                                    aria-controls="users-table"></b-pagination>
                                                <div class="col text-end mt-1">
                                                    <div>
                                                        {{ currentPage }} -
                                                        {{ perPage }} of
                                                        {{ totalRecords }}
                                                    </div>
                                                    <b-form-group label="Per Page" label-size="sm" class="mb-0">
                                                        <b-form-select @change="
                                                            selectPerPage
                                                        " id="per-page-select" v-model="perPage" :options="per_page_options
                                                            " size="sm"></b-form-select>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end row  -->

                    <b-modal size="lg" id="modal-member" @ok="handleOk">
                        <template #modal-title>
                            <h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
                        </template>
                        <audit-filter :form="form" :filterTable="filterTable">
                        </audit-filter>
                        <template #modal-footer="{ ok }">
                            <div class="w-100">
                                <!-- Emulate built in modal footer ok and cancel button actions -->
                                <b-button @click="$bvModal.hide('modal-member')" type="button"
                                    class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
                                        class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
                                    </span></b-button>
                                <b-button @click="ok()" type="submit" :disabled="isSearching"
                                    class="akkurate-green-btn btn-size float-right border-0"><span
                                        class="small"><font-awesome-icon class="me-2"
                                            :icon="['fas', 'search']" />Search</span></b-button>
                            </div>
                        </template>
                    </b-modal>
                </div>
            </div>
            <Footer></Footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import UsersView from "../view/UsersView.vue";
import AuditFilter from "../forms/AuditFilter.vue";
import Multiselect from "vue-multiselect";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        UsersView,
        AuditFilter,
        Multiselect,
        ChatBot,
    },
    mounted() {
        let token = localStorage.getItem("token");
        if (!token) {
            this.$router.push({ path: "/login" });
        }
        this.getAccountDropdown();
        this.loadItems();
    },
    computed: {
        getUsers() {
            if (this.form.users.length > 0) {
                const result = this.form.users.map((index) => {
                    return (
                        index.first_name +
                        " " +
                        index.surname +
                        " - " +
                        index.id
                    );
                });
                // console.log("here");
                return result.join(" | "); // Join array elements with ", "
            } else {
                return "";
            }
        },
    },
    data() {
        return {
            isSearching: false,
            totalRecords: 0,
            searchFilter: "",
            isLoading: true,
            isBusy: true,
            currentPage: 1,
            perPage: 10,
            users_options: [],
            per_page_options: ["10", "20", "50", "100"],
            per_page_selected: "10",
            form: {
                search_term: "",
                from_date: "",
                to_date: "",
                branch: "",
                start_date: "",
                end_date: "",
                users: [],
            },
            fields: [
                {
                    label: "#",
                    key: "index",
                },
                {
                    label: "Reference",
                    key: "ref",
                },
                {
                    label: "Name",
                    key: "name",
                },
                {
                    label: "Download",
                    key: "url",
                },
                {
                    label: "Status",
                    key: "status",
                },
                {
                    label: "Created At",
                    key: "created_at",
                },
                {
                    label: "Actions",
                    key: "actions",
                },
            ],
            rows: [],
        };
    },
    methods: {
        async getAccountDropdown() {
            this.$Progress.start();
            this.isBusy = true;
            await ApiService.get("/accounts/create/dropdown")
                .then((response) => {
                    // console.log(response);
                    // this.form.branch_option = response?.data?.branches;
                    this.users_options = response?.data?.users;
                    this.isBusy = false;
                    this.$Progress.finish();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        fullName({ first_name, surname, code }) {
            let name = "";
            if (first_name) {
                name = name + first_name;
            }

            if (surname) {
                name = name + " " + surname;
            }

            //   if(code)
            //   {
            //     name = name + ` (${code})`;
            //   }

            return `${name}`;
        },
        limitText(count) {
            return `and ${count} other user(s)`;
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            // bvModalEvent.preventDefault();
            // Trigger submit handler
            this.filterTable();
        },
        filterTable() {
            this.loadItems();
        },
        navigatePage(index) {
            this.isBusy = true;
            this.currentPage = index;
            this.loadItems();
        },
        selectPerPage(index) {
            this.perPage = index;
            this.loadItems();
        },
        rowClass() {
            return "custom-row-height";
        },
        getUserLabel({ id, first_name, surname }) {
            return `${id} ${first_name} ${surname}`;
        },

        // load items is what brings back the rows from server
        async loadItems() {
            this.isLoading = true;
            this.isBusy = true;
            this.$Progress.start(); // Start the progress bar

            try {
                const response = await ApiService.post("get-failed-excel-exports", {
                    page: this.currentPage,
                    per_page: this.perPage,
                    filter: this.form.search_term,
                    branch_id: this.form.branch?.id,
                    start_date: this.form.start_date,
                    end_date: this.form.end_date,
                    users: this.form.users.map((user) => user.id),
                });
                this.totalRecords = response.data.data.total;
                this.rows = response.data.data.data;
                console.log(response);
            } catch (error) {
                console.error("Error loading items:", error);
                // Optionally: show a toast or notification
            } finally {
                this.isBusy = false;
                this.isLoading = false;
                this.$Progress.finish();
            }
        },

        confirmDeleteUser(user) {
            swal.fire({
                title: "Disable User",
                text: `Are you sure you want to disable ${user.username}?`,
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                    cancelButton:
                        "btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                },
            }).then((result) => {
                if (result.value) {
                    //   window.location.reload();
                }
            });
        },
        exportToExcel() {
            const workbook = XLSX.utils.book_new();

            // Get the table data
            const tableData = this.$refs.userTable.filteredRows[0].children;

            // Convert the table data to a worksheet
            const worksheet = XLSX.utils.json_to_sheet(tableData);

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            // Generate the Excel file buffer
            const excelBuffer = XLSX.write(workbook, {
                type: "array",
                bookType: "xlsx",
            });

            // Save the Excel file
            FileSaver.saveAs(
                new Blob([excelBuffer], {
                    type: "application/octet-stream",
                }),
                "table_data.xlsx"
            );
        },
        // reverseBulkUpload(trans) {
        //     swal.fire({
        //         title: "Reverse Bulk Upload",
        //         text: `Are you sure you want to reverse transaction with ref: ${trans.ref}?`,
        //         icon: "warning",
        //         showCancelButton: true,
        //         confirmButtonText: "Yes",
        //         cancelButtonText: "No",
        //         allowOutsideClick: true,
        //         customClass: {
        //             confirmButton:
        //                 "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
        //             cancelButton:
        //                 "btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
        //         },
        //     })
        //         .then((result) => {
        //             if (result.value) {
        //                 //   window.location.reload();
        //                 // let url = "/transactions/deposits/reverse";
        //                 // if (trans.transaction_type == "Deposit") {
        //                 // 	url = "/transactions/deposits/reverse";
        //                 // } else if (trans.transaction_type == "Withdrawal") {
        //                 // 	url = "/transactions/withdrawals/reverse";
        //                 // }

        //                 this.$Progress.start();
        //                 ApiService.post('/transactions/bulk/reverse', {
        //                     excel_upload_ref: trans.ref,
        //                     excel_upload_id: trans.id,

        //                 })
        //                     .then((respp) => {
        //                         // console.log(respp);
        //                         //this.isLoading = false;
        //                         this.$Progress.finish();
        //                         toast.fire({
        //                             icon: "success",
        //                             title: respp.data.message,
        //                         });

        //                         this.loadItems();
        //                     })
        //                     .catch((error) => {
        //                         // console.log(error.response.data.message);
        //                         if (error.response.data.message) {
        //                             toast.fire({
        //                                 icon: "error",
        //                                 title: error.response.data.message,
        //                             });
        //                         } else {
        //                             toast.fire({
        //                                 icon: "error",
        //                                 title: "An error occurred",
        //                             });
        //                         }
        //                         this.$Progress.fail();
        //                     });
        //             }
        //         })
        //         .catch((error) => {
        //             console.log(error.response.data.message);
        //             if (error.response.data.message) {
        //                 toast.fire({
        //                     icon: "error",
        //                     title: error.response.data.message,
        //                 });
        //             } else {
        //                 toast.fire({
        //                     icon: "error",
        //                     title: "An error occurred",
        //                 });
        //             }
        //         });
        // },
        reverseBulkUpload(trans) {
            swal.fire({
                title: "Reverse Bulk Upload",
                text: `Are you sure you want to reverse transaction with ref: ${trans.ref}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !swal.isLoading(),
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                    cancelButton:
                        "btn btn-size akkurate-danger-btn modal-btn-width text-white",
                },

                /**  THIS IS THE IMPORTANT PART: async request like the GitHub AJAX EXAMPLE   **/
                preConfirm: async () => {
                    try {
                        const response = await ApiService.post(
                            "/transactions/bulk/reverse",
                            {
                                excel_upload_ref: trans.ref,
                                excel_upload_id: trans.id,
                            }
                        );

                        // If API returned an error status
                        if (!response || response.status !== 200) {
                            return swal.showValidationMessage(
                                `Request failed: ${response?.data?.message || "Unknown error"}`
                            );
                        }

                        return response.data; // Pass data to .then(result)
                    } catch (error) {
                        return swal.showValidationMessage(
                            `${error.response?.data?.message || "Request failed"}`
                        );
                    }
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    // Success alert like the GitHub avatar example
                    swal.fire({
                        icon: "success",
                        title: "Reversal Successful!",
                        text: result.value.message,
                    });

                    this.loadItems();
                }
            });
        }

    },

    // methods: {
    //   getUserOptions() {
    //     this.$Progress.start();
    //     this.isLoading = true;
    //     // axios
    //     //   .get("roles/dropdown")

    //     $(this.$refs.dataTable).DataTable({
    //       serverSide: true,
    //       ajax: {
    //         url: config.api_url + '/users/paginate', // Replace with your server-side endpoint URL
    //         type: 'POST',
    //         beforeSend: function (xhr) {
    //           // Set your authorization header here
    //           xhr.setRequestHeader('Authorization', 'Bearer ' + JwtService.getToken());
    //         },
    //         data: function (data) {

    //           //   this.isLoading = false;
    //           // Customize the request parameters as needed
    //           //   data.page = data.start / data.length + 1;
    //           //   data.pageSize = data.length;
    //           // Add any additional parameters you need, such as sorting information
    //         },
    //         dataSrc: function (json) {
    //           // Handle the server's response here
    //           // Update the DataTables table with the received data
    //           return json.data;
    //         },
    //       },
    //       columns: [
    //         // Define your table columns here
    //         // { data: 'id', title: 'ID' },
    //         { data: 'first_name', title: 'First Name' },
    //         { data: 'surname', title: 'Sur Name' },
    //         { data: 'email', title: 'Email' },
    //         { data: 'username', title: 'Username' },
    //         // Add more columns as needed
    //       ],
    //     });

    //   },
    // }
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
